import axios from 'axios';

import buildPaginationQueryOpts from '@/shared/sort/sorts';
import { IUserAccess } from '@/shared/model/user-access.model';
import { buildURLQueryOpts } from '@/shared/query/query';

const baseApiUrl = 'api/v1/user-accesses';

export default class UserAccessService {
  public find(userAccess: any): Promise<IUserAccess> {
    let query = '';
    const payload = {
      ...userAccess,
    };
    query = `${payload.userAccessId}?companyId=${payload.companyId}`;
    if (!payload.companyId) {
      query = payload.userAccessId;
    }

    return new Promise<IUserAccess>((resolve, reject) => {
      axios
        .get(`${baseApiUrl}/${query}`)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public retrieve(paginationQuery?: any, searchQuery?: any): Promise<any> {
    let query = buildPaginationQueryOpts(paginationQuery);
    if (paginationQuery && paginationQuery.companyId) {
      query = query + `&companyId=${paginationQuery.companyId}`;
    }
    if (buildURLQueryOpts(searchQuery) !== '') {
      query = query + `&${buildURLQueryOpts(searchQuery)}`;
    }

    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `?${query}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
  public retrieveAccessByUserId(userId: number, params?: any): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .get(baseApiUrl + `/${userId}?showAllAccess=${params}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public delete(id: number, companyId: number): Promise<any> {
    return new Promise<any>((resolve, reject) => {
      axios
        .delete(`${baseApiUrl}/${id}?companyId=${companyId}`)
        .then(res => {
          resolve(res);
        })
        .catch(err => {
          reject(err);
        });
    });
  }

  public create(entity: IUserAccess): Promise<IUserAccess> {
    return new Promise<IUserAccess>((resolve, reject) => {
      axios
        .post(`${baseApiUrl}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          resolve(err.response.data);
        });
    });
  }

  public update(entity: IUserAccess): Promise<IUserAccess> {
    const { id } = entity;
    return new Promise<IUserAccess>((resolve, reject) => {
      axios
        .put(`${baseApiUrl}/${id}`, entity)
        .then(res => {
          resolve(res.data);
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
